export default __webpack_public_path__ + "static/media/技术专家交流.c285253b.png";